export const  POST_CONTENT_EMAIL_SUCCESS='contentEmailReducer/POST_CONTENT_EMAIL_SUCCESS';
export const  POST_CONTENT_EMAIL_REQUEST='contentEmailReducer/POST_CONTENT_EMAIL_REQUEST';
export const  POST_CONTENT_EMAIL_FAILED='contentEmailReducer/POST_CONTENT_EMAIL_FAILED';